"use client";

import { c as _c } from "react/compiler-runtime";
import posthog from "posthog-js";
import { PostHogProvider as PHProvider, usePostHog } from "posthog-js/react";
import { Suspense, useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { useSession } from "next-auth/react";
export function PostHogProvider(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  if (!process.env.NEXT_PUBLIC_POSTHOG_KEY) {
    let t2;
    if ($[1] !== children) {
      t2 = <>{children}</>;
      $[1] = children;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SuspendedPostHogPageView />;
    t3 = <PostHogUserIdentification />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children) {
    t4 = <PHProvider client={posthog}>{t2}{t3}{children}</PHProvider>;
    $[5] = children;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
function _temp() {
  if (process.env.NEXT_PUBLIC_POSTHOG_KEY) {
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
      api_host: "/tsegni",
      ui_host: "https://eu.posthog.com",
      capture_pageview: false,
      capture_pageleave: true,
      debug: process.env.NODE_ENV === "development"
    });
  }
}
function PostHogUserIdentification() {
  const $ = _c(4);
  const {
    data: session
  } = useSession();
  const posthog = usePostHog();
  let t0;
  let t1;
  if ($[0] !== posthog || $[1] !== session) {
    t0 = () => {
      if (session?.user) {
        posthog.identify(session.user.id, {
          email: session.user.email,
          name: session.user.name,
          familyName: session.user.familyName,
          givenName: session.user.givenName,
          locale: session.user.locale
        });
      } else {
        posthog.reset();
      }
    };
    t1 = [session, posthog];
    $[0] = posthog;
    $[1] = session;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return null;
}
function PostHogPageView() {
  const $ = _c(5);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const posthog = usePostHog();
  let t0;
  let t1;
  if ($[0] !== pathname || $[1] !== posthog || $[2] !== searchParams) {
    t0 = () => {
      if (pathname && posthog) {
        let url = window.origin + pathname;
        const search = searchParams?.toString();
        if (search) {
          url = url + ("?" + search);
        }
        posthog.capture("$pageview", {
          $current_url: url
        });
      }
    };
    t1 = [pathname, searchParams, posthog];
    $[0] = pathname;
    $[1] = posthog;
    $[2] = searchParams;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  return null;
}
function SuspendedPostHogPageView() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Suspense fallback={null}><PostHogPageView /></Suspense>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}